import type { LoggedInUserData } from '@/stores/app'

export interface JWTClaims extends LoggedInUserData {
    exp?:  number
    role?: string
}

export const parseJWT = (jwt: string): JWTClaims | null => {
    const payload = jwt.split('.')[1]
    if (!payload) return null

    try {
        const bytes = Uint8Array.from(atob(payload.replace(/-/g, '+').replace(/_/g, '/')), (c) => c.charCodeAt(0))
        return JSON.parse(new TextDecoder().decode(bytes)) as JWTClaims
    } catch {
        return null
    }
}

export const isJWTValid = (jwt: string): boolean => {
    const claims = parseJWT(jwt)
    if (!claims) return false
    return !claims.exp || claims.exp * 1000 > Date.now() + 30_000
}
